// extracted by mini-css-extract-plugin
export default {"zone":"wyo7dTB0","leftArrow":"E8SKNOJE","gallery":"gallery","rightArrow":"JaK69p2v","fullscreen":"Q6j_mYKD","disabledZone":"yZjJ490E"};